module.exports = __webpack_public_path__ + "static/media/CTLI_13-293w.fb1a4c18.webp";